<template>
  <div class="home-wrap">
    <div class="banner">
      <img src="@/assets/images/banner.png" alt="">
    </div>
    <aboutus />
    <management />
    <!-- <help /> -->
    <atlas />
    <industry />
  </div>
</template>

<script>
// import trait from '@/components/home/trait'
import management from '@/components/home/management'
import help from '@/components/home/help'
import atlas from '@/components/home/atlas'
import industry from '@/components/home/industry'
import aboutus from '@/components/home/aboutus'
export default {
  components: {
    // trait,
    management,
    help,
    atlas,
    industry,
    aboutus
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/sass/variable.sass';
.home-wrap {
  width: 100%;
  overflow: hidden;
  .banner{
    img {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newHome.vue